import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({ theme }) => css`
        width: 100%;
        height: 100%;
        .rdt_TableCol_Sortable > div {
            font-weight: bold;
        }

        .ant-pagination {
            justify-content: flex-end;
            display: flex;
            margin: 2rem auto;
        }

        .rdt_TableCol {
            border: 0.5px solid ${theme.colors.lightGrey};
        }

        .rdt_TableHeadRow {
            border-bottom-style: none;
            /* border-color: black; */
        }

        .rdt_TableCell {
            border: 0.5px solid ${theme.colors.lightGrey};
            border-top: 0;
            font-size: ${theme.fontSizes.default};
        }
        .fCDpbe:not(:last-of-type) {
            border-bottom-style: none;
        }
    `}
`;

export const TextField = styled.input`
    height: 32px;
    width: 200px;
    border-radius: 3px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid #e5e5e5;
    padding: 0 32px 0 16px;

    &:hover {
        cursor: pointer;
    }
`;

export const NoData = styled.span`
    ${() => css`
        font-size: 1.4rem;
    `}
`;

export const TitleLoadingTable = styled.span`
    ${() => css`
        font-size: 1.4rem;
        font-weight: bolder;
    `}
`;
